import { singleton, observable, computedFrom, autoinject } from "aurelia-framework";
import { DialogService } from 'aurelia-dialog';
import { BusyService } from "../services/busy-service";
import { WebApiService } from "../services/web-api-service";
import { UpdateUserDialog } from "./dialogs/update-user-dialog";
import { activationStrategy, Router } from 'aurelia-router';
import 'jquery';
import { UpdateUserModel } from "../data/typegen/dtos/update-user-model";
import { ShortDateValueConverter } from "../resources/value-converters/short-date";
import { ShortDateTimeValueConverter } from "../resources/value-converters/short-date-time";

@singleton()
@autoinject()
export class UserAdmin {

    constructor(
        private shortDateConverter: ShortDateTimeValueConverter,
        private dialogService: DialogService,
        private router: Router,
        private busyService: BusyService,
        private api: WebApiService) {
    }

    async activate(params) {
        await this.loadUsers();

        if (params.user_id) {
            this.handleUserIdQueryParam(params.user_id);
        }
    }

    async handleUserIdQueryParam(userId) {

        var user = this.gridData.find(o => o.id == userId);
        if (user) {
            await this.editUser(user);
            this.router.navigateToRoute("user-admin");
        }
    }

    @observable()
    filterActive: string = "active";
    filterActiveChanged() {
        this.filterList();
    }

    @observable
    quickFilter: string;
    quickFilterChanged() {
        this.gridOptions.api && this.gridOptions.api.setQuickFilter(this.quickFilter);
    }

    filterList() {
        if (this.gridData) {
            this.filteredGridData = this.gridData.filter(o => {
                let thouShaltNotPass = false;
                if (this.filterActive) {
                    if (this.filterActive == "inactive") {
                        if (o.active) {
                            thouShaltNotPass = true;
                        }
                    } else if (this.filterActive == "active") {
                        if (!o.active) {
                            thouShaltNotPass = true;
                        }
                    }
                }
                return !thouShaltNotPass;
            });
        }
    }

    loadUsers() {
        this.busyService.on();
        return this.api.get("Auth", "GetUsers")
            .then((result) => {
                const users = JSON.parse(result.response);
                users.forEach(user => {
                    user.millCodes = user.millCodes ? user.millCodes.split(',') : [];
                    user.roles = user.roles ? user.roles.split(',') : [];
                });
                this.gridData = users;
                this.filterList();
            })
            .finally(() => this.busyService.off());
    }

    columnDefs: Array<any> = [
        {
            headerName: "", field: "auth0UserId",
            width: 30,
            cellRenderer: (params) => {
                if (params.value != null) {
                    return `<i title="Linked to Auth0  ID=${params.value}" class="fa fa-link"></i>`;
                }
                return `<span title="Not linked to Auth0">&nbsp;&nbsp;&nbsp;&nbsp;</span>`;
            }
        },
        {
            headerName: "", field: "active", filter: 'bool',
            width: 30,
            cellRenderer: (params) => {
                if (params.value) {
                    return `<i title="Active" class="fa fa-check"></i>`;
                } else {
                    return `<i title="Inactive" class="text-danger fa fa-times"></i>`;
                }
                return "";
            }
        },
        {
            headerName: "User Name", field: "userName", filter: 'text',
            cellRenderer: (params) => {
                if (params.value != null) {
                    return `<a href="javascript:void(0)" user-link="true">${params.value}</a>`;
                }
                return params.value;
            }
        },
        
        { headerName: "Roles", field: "roles", filter: 'text' },
        { headerName: "Divisions", field: "millCodes", filter: 'text' },
        {
            headerName: "Last Login", field: "lastLoginOn", filter: 'bool',
            cellRenderer: (params) => {
                let lastLogin = this.shortDateConverter.toView(params.value);
                if(lastLogin){
                    lastLogin += " (CST)";
                }
                return lastLogin;
            },
        },
        {
            headerName: "Receive Carrier Report", field: "receiveAutomatedCarrierStatusReport",
            cellRenderer: (params) => {
                if (params.value) {
                    return "Yes";
                } else {
                    return "No";
                }
            }
        },
        {
            headerName: "Combine Reports", field: "combineReports",
            cellRenderer: (params) => {
                if (params.value) {
                    return "Yes";
                } else {
                    return "No";
                }
            }
        },
        { field: "id", visible: false }
    ];

    gridOptions = {
        api: undefined,
        columnDefs: this.columnDefs,
        onRowClicked: (e) => this.onRowClicked(e),
        //pagination controls require v9 or greater.
        pagination: true,
        paginationPageSize: 100,
        //paginationAutoPageSize : true
    };

    createNewUser() {
        this.dialogService.open(
            {
                viewModel: UpdateUserDialog,
                model: {
                    user: {}
                }
            })
            .whenClosed((result) => {
                if (!result.wasCancelled) {
                    //reload users
                    this.loadUsers();
                }
            });
    }
    gridApi: any;

    exportGrid() {
        this.gridApi.exportDataAsCsv({
            fileName: "cmp_users.csv"
        });
    }

    refresh() {
        this.loadUsers();
    }


    onReady(event) {
        this.gridApi = this.gridOptions.api;
    }

    onRowClicked(e) {
        if (e.event.target !== undefined) {
            let data = e.data;
            let actionType = e.event.target.getAttribute("user-link");
            if (actionType == "true") {
                this.editUser(data);
            }
        }
    }

    async editUser(data) {
        // create user object for editing
        const updateUserModel: UpdateUserModel = Object.assign(new UpdateUserModel(), data);
        await this.dialogService.open(
            {
                viewModel: UpdateUserDialog,
                model: {
                    user: updateUserModel,
                    createOnSave: false
                }
            })
            .whenClosed((result) => {
                if (!result.wasCancelled) {
                    //reload users
                    return this.loadUsers();
                }
            });
    }

    gridData = [];
    filteredGridData = [];

}
